import {TestOrderStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getTestOrderStatusDisplayText} from 'sample-tests/ui/utils/TestOrderStatusUtil';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getTestStatusOptionDatas(): Promise<Array<OptionData>> {
  return Promise.resolve(
    Object.values(TestOrderStatus).map((testStatus) => ({
      value: testStatus,
      name: getTestOrderStatusDisplayText(TestOrderStatus[testStatus as keyof typeof TestOrderStatus]),
    }))
  );
}
